module.exports = require('./src/base64');
